import { RulesApi } from './rulesApi';

const rulesApi = new RulesApi();

export { rulesApi };
